<style>
.img-fluid{
cursor: pointer;
}

.centered-link{
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  font-size: 0.9em;
  text-align: center;
}

.slick-slider[data-v-3d1a4f76] {
width: 60%;

}

.col-lg-7 {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.slick-slide img[data-v-e4caeaf8] {
    display: block;
}
.data-v-e4caeaf8{
  width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.slick-arrow {
  font-size: 24px;
  color: #333;
  z-index: 10;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.slick-arrow:hover {
color: #045C68;

}

.slick-prev {
  font-size: 3em;
  left: -30px;
}

.slick-next {

  font-size: 3em;
  right: -30px;
}
</style>

<template>
  <div id="lactationedn-view">
    <head>
      <meta name="description" content="ResMed Masks">
    </head>
    <section class="bg-light ftco-section">
      <div class="container" style="min-width: 90vw;">
        <h1 class="display-4 text-center  my-4">RESMED CPAP MASKS<br>
        <Span style="font-size: 0.3em;">(prescription required)</Span>
        </h1>
        <div class="row  my-5">
          <div class="col-md-12 col-lg-7">
            <VueSlickCarousel 
            ref="mainSlider"
            :arrows="true" 
            :fade="true" 
            :as-nav-for="$refs.thumbnailSlider"
            >
        <div v-for="image in images" :key="image.id">
          <img :src="image.src" :alt="image.alt" class="img-fluid" />
        </div>
        <template v-slot:prevArrow>
        <button class="slick-arrow slick-prev">
          <i class="fas fa-chevron-left"></i>
        </button>
      </template>
      <template v-slot:nextArrow>
        <button class="slick-arrow slick-next">
          <i class="fas fa-chevron-right"></i>
        </button>
      </template>
      </VueSlickCarousel>
      <VueSlickCarousel
        :slides-to-show="5"
        :focus-on-select="true"
        :as-nav-for="$refs.mainSlider"
        class="mt-2"
      >
        <div v-for="image in images" :key="image.id">
          <img :src="image.thumbnail" :alt="image.alt" class="img-fluid" />
        </div>
      </VueSlickCarousel>
          </div>
          <div class="col-md-12 col-lg-5">
            <h3 class="mt-5 mb-2 text-light1">Quattro Air for Her Full Face Mask</h3>
            <div class="row mb-4">
              <div class="col">
                <span class="text3">Description</span>
              </div>
            </div>
            <p>
                ResMed's Quattro series has earned a reputation for high performance, excellent seal quality, and proven reliability so it is no surprise that the Quattro series is one of ResMed's best-selling full face masks. Designed with all the positive features of the Quattro masks, ResMed cut the weight of the mask almost in half to create the new Quattro Air. It's lighter, sleeker, simpler to use, and even more comfortable than its predecessors while reaching all the performance attributes that have made the Quattro series a winner in the market.

The ResMed Quattro Air Full Face mask is loaded with features that work on simplifying the user experience to encourage easy patient acceptance. It's ideal for the newly diagnosed as well as for existing full face mask patients looking for a lightweight, comfortable, and simple to use alternative. ResMed Quattro Air is one of the lightest full-face masks on the market plus it offers improved comfort over the previous masks.

The ResMed Quattro Air is a lightweight full-face mask that offers more comfort. Weighing just over 3 ounces, the Quattro Air delivers less bulk than traditional CPAP masks, giving you the feeling of wearing no mask at all. Other features, like extra cushioning around the nose bridge and SoftEdge headgear provide the most comfortable experience in CPAP full-face masks.

            </p>
            <div class="row mb-4">
              <div class="col">
              </div>
            </div>
            
              <div id="action-buttons" class="d-flex justify-content-between">
    <router-link to="/cpapform" class="btn btn-light mt-3" style="white-space: normal; font-size: 13px !important;" tag="button">
      Purchase with insurance
    </router-link>
  </div>

          </div>
        </div>
        <div class="row my-5">
  <div class="col-md-6">
    <h3 class="mt-5 mb-2 text-light1">Ideal For</h3>
    <ul>
      <li>
        Light Sleepers
      </li>
      <li>
        Petite Facial Structures
      </li>
      <li>
        If You Breathe Through Your Mouth or Nose
      </li>
      <li>
        If You Have Sensitive Skin
      </li>
    </ul>
  </div>
  <div class="col-md-6">
    <h3 class="mt-5 mb-2 text-light1">Features</h3>
    <ul>
        <li>
        Easy-to-Use Design and Easy Cleaning
      </li>
      <li>
        Open Line of Sight
      </li>
      <li>
        Spring Air Cushion Offers Comfort and Strengthens Seal
      </li>
      <li>
        SoftEdge Headgear Features Feminine Touches
      </li>
      <li>
        Quick Release Elbow and Circular Vent Permit Movement and Reduce Noise
      </li>
    </ul>
  </div>
</div>
      </div>      
    </section>
  </div> 
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  components: {
    VueSlickCarousel,
  },
  data() {
  return {
    images: [
    { id: 1, src: require('@/assets/site/CPAP/QuattroAirforHerFullFaceMask/1.webp'), thumbnail: require('@/assets/site/CPAP/QuattroAirforHerFullFaceMask/1.webp'), alt: 'Image 1' },
    { id: 2, src: require('@/assets/site/CPAP/QuattroAirforHerFullFaceMask/2.jpg'), thumbnail: require('@/assets/site/CPAP/QuattroAirforHerFullFaceMask/2.jpg'), alt: 'Image 2' },
    ],
  }
},
mounted() {
  this.$nextTick(() => {
    const arrows = this.$el.querySelectorAll('.slick-arrow');
    arrows.forEach(arrow => {
      arrow.addEventListener('click', () => {
        arrow.blur();
      });
    });
  });
}

}
</script>
